'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UINumberInput = require('./UINumberInput');

var _UINumberInput2 = _interopRequireDefault(_UINumberInput);

var _UIButtonGroup = require('../button/UIButtonGroup');

var _UIButtonGroup2 = _interopRequireDefault(_UIButtonGroup);

var _UIButton = require('../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _colors = require('HubStyleTokens/colors');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Functions = require('../core/Functions');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Dom = require('../utils/Dom');

var _DomEvents = require('../utils/DomEvents');

var _ShareInput = require('../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isIncrementDisabled = function isIncrementDisabled(stepSize, value, max, disabled) {
  if (disabled) return true;
  if (max == null) return false;

  return !(value + stepSize <= max);
};

var isDecrementDisabled = function isDecrementDisabled(stepSize, value, min, disabled) {
  if (disabled) return true;
  if (min == null) return false;

  return !(value - stepSize >= min);
};

var UIStepperInput = _react2.default.createClass({
  displayName: 'UIStepperInput',

  propTypes: _extends({}, _UINumberInput2.default.propTypes, {
    disabledMaxButtonTooltip: _react.PropTypes.node,
    disabledMinButtonTooltip: _react.PropTypes.node,
    value: _react.PropTypes.number,
    stepSize: _react.PropTypes.number,
    onChange: _react.PropTypes.func.isRequired,
    onStep: _react.PropTypes.func,
    inputClassName: _react.PropTypes.string
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UINumberInput2.default.defaultProps, {
      stepSize: 1
    });
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._repeatHandle != null) {
      this._repeatHandle.stop();
    }
  },
  handleStep: function handleStep(step) {
    var _props = this.props,
        disabled = _props.disabled,
        inputRef = _props.inputRef,
        max = _props.max,
        min = _props.min,
        onChange = _props.onChange,
        onStep = _props.onStep,
        readOnly = _props.readOnly,
        value = _props.value;

    if (readOnly || disabled) return;

    if (inputRef.current) inputRef.current.focus();

    var newValue = (value || 0) + step;
    var fencedMin = min == null ? newValue : Math.max(newValue, min);
    var fencedValue = max == null ? fencedMin : Math.min(fencedMin, max);

    onChange((0, _SyntheticEvent2.default)(fencedValue));
    (0, _Functions.callIfPossible)(onStep, (0, _SyntheticEvent2.default)(fencedValue));
  },
  increment: function increment() {
    if (this._freeze) return;
    var stepSize = this.props.stepSize;

    this.handleStep(stepSize);
  },
  decrement: function decrement() {
    if (this._freeze) return;
    var stepSize = this.props.stepSize;

    this.handleStep(-stepSize);
  },
  handleUpArrowMouseDown: function handleUpArrowMouseDown(evt) {
    if ((0, _DomEvents.isLeftClick)(evt)) {
      this.startMouseHold('increment');
    }
  },
  handleDownArrowMouseDown: function handleDownArrowMouseDown(evt) {
    if ((0, _DomEvents.isLeftClick)(evt)) {
      this.startMouseHold('decrement');
    }
  },
  handleArrowMouseUp: function handleArrowMouseUp() {
    this.stopMouseHold();
  },
  startMouseHold: function startMouseHold(action) {
    this._repeatHandle = (0, _Dom.repeatUntilEventOnElement)(this[action], 100, document.documentElement, ['mouseup']);
  },
  stopMouseHold: function stopMouseHold() {
    var _this = this;

    // Prevent click event from triggering an extra increment/decrement after click-and-hold
    if (this._repeatHandle && this._repeatHandle.count >= 1) {
      this._freeze = true;
      setTimeout(function () {
        _this._freeze = 0;
      }, 0);
    }
    this._repeatHandle = null;
  },
  handleKeyDown: function handleKeyDown(evt) {
    var onKeyDown = this.props.onKeyDown;
    var key = evt.key;

    if (key === 'ArrowUp') {
      evt.preventDefault();
      this.increment();
    } else if (key === 'ArrowDown') {
      evt.preventDefault();
      this.decrement();
    }
    (0, _Functions.callIfPossible)(onKeyDown, evt);
  },
  inputRefCallback: function inputRefCallback(ref) {
    this._inputRef = ref;
  },
  render: function render() {
    var _props2 = this.props,
        className = _props2.className,
        disabled = _props2.disabled,
        disabledMaxButtonTooltip = _props2.disabledMaxButtonTooltip,
        disabledMinButtonTooltip = _props2.disabledMinButtonTooltip,
        inputClassName = _props2.inputClassName,
        max = _props2.max,
        min = _props2.min,
        readOnly = _props2.readOnly,
        stepSize = _props2.stepSize,
        value = _props2.value,
        rest = _objectWithoutProperties(_props2, ['className', 'disabled', 'disabledMaxButtonTooltip', 'disabledMinButtonTooltip', 'inputClassName', 'max', 'min', 'readOnly', 'stepSize', 'value']);

    var classes = (0, _classNames2.default)('private-stepper-input', className);

    var inputClasses = (0, _classNames2.default)('private-stepper-input--input', inputClassName);

    var incrementDisabled = isIncrementDisabled(stepSize, value, max, disabled);
    var decrementDisabled = isDecrementDisabled(stepSize, value, min, disabled);

    return _react2.default.createElement(
      'div',
      { className: classes },
      _react2.default.createElement(_UINumberInput2.default, _extends({}, rest, {
        'aria-valuemax': max,
        'aria-valuemin': min,
        'aria-valuenow': value,
        disabled: disabled,
        className: inputClasses,
        max: max,
        min: min,
        onKeyDown: this.handleKeyDown,
        readOnly: readOnly,
        role: 'spinbutton',
        value: value
      })),
      readOnly ? null : _react2.default.createElement(
        _UIButtonGroup2.default,
        {
          className: 'private-stepper-input--buttons',
          orientation: 'vertical'
        },
        _react2.default.createElement(
          _UITooltip2.default,
          {
            autoPlacement: 'vert',
            placement: 'top left',
            title: disabledMaxButtonTooltip,
            disabled: !incrementDisabled
          },
          _react2.default.createElement(
            _UIButton2.default,
            {
              'aria-hidden': true,
              disabled: incrementDisabled,
              onClick: this.increment,
              onMouseDown: this.handleUpArrowMouseDown,
              onMouseUp: this.handleArrowMouseUp,
              'data-action': 'increment',
              use: 'tertiary-light',
              size: 'small',
              tabIndex: -1
            },
            _react2.default.createElement(_UIIcon2.default, { name: 'up', color: !incrementDisabled ? _colors.CALYPSO : null })
          )
        ),
        _react2.default.createElement(
          _UITooltip2.default,
          {
            autoPlacement: 'vert',
            placement: 'top left',
            title: disabledMinButtonTooltip,
            disabled: !decrementDisabled
          },
          _react2.default.createElement(
            _UIButton2.default,
            {
              'aria-hidden': true,
              disabled: decrementDisabled,
              onClick: this.decrement,
              onMouseDown: this.handleDownArrowMouseDown,
              onMouseUp: this.handleArrowMouseUp,
              'data-action': 'decrement',
              use: 'tertiary-light',
              tabIndex: -1,
              size: 'small'
            },
            _react2.default.createElement(_UIIcon2.default, {
              name: 'down',
              color: !decrementDisabled ? _colors.CALYPSO : null
            })
          )
        )
      )
    );
  }
});

exports.default = (0, _ShareInput2.default)((0, _Controllable2.default)(UIStepperInput));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/UIStepperInput.js
// module id = 701
// module chunks = 3 4